import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.prueflauf-aufgabe-bild';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPrueflaufAufgabeBildEffects {

    PrueflaufAufgabeBild$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PRUEFLAUF_AUFGABE_BILD),
        mergeMap((x: ac.GetPrueflaufAufgabeBildAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getPrueflaufAufgabeBild(x.prueflauf_id, x.aufgabe_id, x.bild_id, x.width, x.height).pipe(
                map((result: any) => {
                    return new ac.GetPrueflaufAufgabeBildErfolgreichAction(result, x.prueflauf_id, x.aufgabe_id, x.bild_id, x.width, x.height, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetPrueflaufAufgabeBildFehlerAction(error, x.prueflauf_id, x.aufgabe_id, x.bild_id, x.width, x.height, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufQueryService);
        }
        return this.service;
    }
}
